import "./App.css";
import { Provider } from "react-redux";
import { initializeNotification } from "./config/notificationConfig";
import { useRoutes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";
import { routes } from "./routing/routes";

const queryClient = new QueryClient();

initializeNotification();

function App() {
  const appElements = useRoutes(routes);

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          {appElements}
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
